import React, { useEffect, useState } from "react";
import { useMap } from "./Context";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import TileWMS from "ol/source/TileWMS";
// import Source from "ol/source/Source";
import Zoom from "ol/control/Zoom";
// import ScaleLine from "ol/control/ScaleLine";
// import { toLonLat } from "ol/proj";
import Control from "ol/control/Control"; // Add this import
import { fromLonLat } from "ol/proj";
import "ol/ol.css";
import "./BaseMap.scss";
import { useSelector } from "react-redux";
import LatLonDisplay from "./LatLonDisplay";
import TileSource from "ol/source/Tile";
import { useGeolocation } from "@gis/components/useGeoLocation";
import center from "@assets/svg/center.svg";
import GISDropdown from "../GISCustomWrapper/GISDropdown";

interface BaseMapProps {
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  hideLatLon?: boolean;
}

const GEO_SERVER_URL = `${process.env.REACT_APP_API_GEOSERVER_URL}/geoserver/noc/wms`;

const BaseMap = ({
  width = "100%",
  height = "100vh",
  style,
  hideLatLon,
}: BaseMapProps) => {
  const { map, mapRef } = useMap();
  const [latLong, setLatLong] = useState({ lat: "", lon: "" });

  const {
    coordinates: geoCoordinates,
    error,
    isLoading,
  } = useGeolocation({
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  });

  const selectedBaseMap = useSelector(
    (state: any) => state.gisData?.selectedBaseMap || ""
  ); 
  const sources: Record<string, TileSource> = {
    osm: new OSM(),
    satellite: new XYZ({
      url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
    }),
    terrain: new XYZ({
      url: "https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png",
    }),
    roadmap: new XYZ({
      url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
    }),
    hybrid: new XYZ({
      url: "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
    }),
    // bhuvanBase: new TileWMS({
    //   url: "https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms",
    //   params: {
    //     LAYERS: "india3",
    //     FORMAT: "image/jpeg",
    //     SRS: "EPSG:4326",
    //     VERSION: "1.1.1",
    //     TRANSPARENT: true,
    //   },
    // }),
    // bhuvanImagery: new TileWMS({
    //   url: "https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py",
    //   params: {
    //     LAYERS: "bhuvan_imagery",
    //     FORMAT: "image/jpeg",
    //     SRS: "EPSG:4326",
    //     VERSION: "1.1.1",
    //     TRANSPARENT: true,
    //   },
    // }),
  };


  useEffect(() => {
    if (!map || !mapRef.current) return;

    map.setTarget(mapRef.current);

    map
      .getLayers()
      .getArray()
      .filter((layer: any) => layer.nocOverlay)
      .forEach((layer: any) => map.removeLayer(layer));

    const controls = map.getControls().getArray();

    if (!controls.some((control: any) => control instanceof Zoom)) {
      map.addControl(
        new Zoom({
          className: "custom-zoom",
          zoomInLabel: "+",
          zoomOutLabel: "-",
        })
      );
    }
    map.getControls().getArray().forEach((control: any) => {
      const el = control.element || control.getElement?.();
      if (el && el.classList.contains('center-location')) {
        map.removeControl(control);
      }
    });

    // Add the center location control (only one will exist now)
    const centerButton = document.createElement("button");
    centerButton.title = "Center on Current Location";
    centerButton.className = "center-location-button";

    const icon = document.createElement("img");
    icon.src = center;            // expand is the imported svg path
    icon.alt = "Center";
    icon.className = "center-location-icon";
    centerButton.appendChild(icon);

    // Wrap button in a container so we can reliably detect/remove it
    const centerContainer = document.createElement("div");
    centerContainer.className = "center-location ol-unselectable ol-control";
    centerContainer.appendChild(centerButton);

    const centerControl = new Control({
      element: centerContainer,
    });

    centerButton.addEventListener("click", () => {
      if (geoCoordinates && geoCoordinates.latitude && geoCoordinates.longitude) {
        const view = map.getView();
        const center = fromLonLat([geoCoordinates.longitude, geoCoordinates.latitude]);
        view.setCenter(center);
        view.setZoom(15);
      } else {
        alert("Current location not available. Please enable location services.");
      }
    });

    map.addControl(centerControl);

    const existingLayer = map.getLayers().item(0);
    if (!existingLayer) {
      map.getLayers().insertAt(
        0,
        new TileLayer<TileSource>({
          source: sources[selectedBaseMap],
        })
      );
    }

    const tiless = [
      "nh_layer_entrument_buffer_300_final",
      "nh_layer_entrument",
      "state boundaries",
      "india boundaries",
      "Chainages",
    ];

    tiless.forEach((layerName) => {
      let tileLayer = new TileLayer({
        source: new TileWMS({
          url: `${GEO_SERVER_URL}`,
          params: {
            TILED: true,
            LAYERS: `noc:${layerName}`,
          },
          serverType: "geoserver",
          crossOrigin: "anonymous",
        }),
        opacity: 1,
      });
      // Tag the layer
      (tileLayer as any).nocOverlay = true;
      map.addLayer(tileLayer);
    });
  }, [map, mapRef, sources, selectedBaseMap]);

  useEffect(() => {
    if (!map) return;
    const baseLayer = map.getLayers().item(0) as TileLayer<TileSource>;
    if (baseLayer) {
      baseLayer.setSource(sources[selectedBaseMap]);
    }
  }, [selectedBaseMap, map, sources, geoCoordinates]);

  return (
    <div ref={mapRef} style={{ width, height, ...style, position: "relative" }}>
      <GISDropdown/>
      {/* {hideLatLon === null || hideLatLon === undefined ? null : (
        <LatLonDisplay lat={latLong.lat} lon={latLong.lon} />
      )} */}
    </div>
  );
};

export default BaseMap;
